import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 50000 72273"
    {...props}
  >
    <path
      d="m15833 22586-835 4742c4621-2469 8892-3704 12813-3704 3120 0 6039 584 8775 1752 2719 1184 5105 2802 7141 4871 2052 2069 3669 4521 4837 7341 227 550 432 1108 614 1674H34932c-1066-1930-2448-3391-4135-4393-1852-1084-3937-1635-6207-1635-2802 0-4805 350-6022 1034-1202 684-2936 1868-5205 3587-2252 1702-4121 2569-5590 2569-1600 0-3019-584-4253-1735-1235-1168-1852-2469-1852-3937 0-167 167-1268 533-3320l1552-8846h12080zm34167 28499c-455 3042-1405 5885-2853 8542-2119 3871-5173 6940-9159 9225-3972 2286-8575 3421-13797 3421-5823 0-10562-1068-14198-3220-3637-2153-6206-4621-7724-7408C751 58876 0 56441 0 54355c0-1268 533-2486 1584-3621 1068-1134 2386-1701 3988-1701 2736 0 4771 1568 6105 4738 1302 2903 3071 5155 5290 6773 2218 1619 4688 2419 7423 2419 2503 0 4705-650 6590-1952 1903-1301 3353-3103 4388-5388 623-1391 1059-2905 1303-4538h13329zM5826 10763l480-2738c451-2803 1301-4838 2535-6106C10093 635 12111 0 14914 0h25793c5072 0 7608 1935 7608 5823 0 1702-618 3070-1853 4121-380 324-815 597-1306 819H5826z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
